import {createAction} from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  GET, LIBRARY, CURRENT, MATERIAL, SET, EDIT, TYPES, DELETE, COPY, TEST
} from "../../constants";

export const getLibraryAction = createAction<any>(GET + LIBRARY + FETCH);
export const getLibraryActionDone = createAction<any>(GET + LIBRARY + FETCH + DONE);
export const getLibraryActionFail = createAction<undefined>(GET + LIBRARY + FETCH + FAIL);

export const getLibraryCurrentAction = createAction<any>(GET + LIBRARY + CURRENT + FETCH);
export const getLibraryCurrentActionDone = createAction<any>(GET + LIBRARY + CURRENT + FETCH + DONE);
export const getLibraryCurrentActionFail = createAction<undefined>(GET + LIBRARY + CURRENT + FETCH + FAIL);

export const copyTypeAction = createAction<any>(SET + COPY + TYPES + FETCH);
export const copyTypeActionDone = createAction<any>(SET + COPY + TYPES + FETCH + DONE);
export const copyTypeActionFail = createAction<undefined>(SET + COPY + TYPES + FETCH + FAIL);

export const editTypeAction = createAction<any>(SET + EDIT + TYPES + FETCH);
export const editTypeActionDone = createAction<any>(SET + EDIT + TYPES + FETCH + DONE);
export const editTypeActionFail = createAction<undefined>(SET + EDIT + TYPES + FETCH + FAIL);

export const deleteTypeAction = createAction<any>(SET + DELETE + TYPES + FETCH);
export const deleteTypeActionDone = createAction<any>(SET + DELETE + TYPES + FETCH + DONE);
export const deleteTypeActionFail = createAction<undefined>(SET + DELETE + TYPES + FETCH + FAIL);

export const copyTestAction = createAction<any>(SET + COPY + TEST + FETCH);
export const copyTestActionDone = createAction<any>(SET + COPY + TEST + FETCH + DONE);
export const copyTestActionFail = createAction<undefined>(SET + COPY + TEST + FETCH + FAIL);